import { Group, Text } from '@mantine/core';
import { NavLink } from 'react-router-dom';
import { formatTimestamp } from '../../../utils/TableTimestamps';
import { rbacActions } from '../../../config/rbac/actions';
import { Message } from '../types';
import { Contact } from '../../contacts/types';
import { AddToContactsButton } from '../buttons/AddToContactsButton';

export const useMessageProfile = (
    record: Message,
    onAddToContacts?: () => void,
    existingContact?: Contact | null,
) => {
    let fromValue: React.ReactNode = record.fromText;

    if (existingContact) {
        fromValue = (
            <NavLink to={`/contacts/${existingContact.id}`} style={{ textDecoration: 'none' }}>
                <Text size="sm" c="blue">{record.fromText}</Text>
            </NavLink>
        );
    } else if (onAddToContacts) {
        fromValue = (
            <Group gap="xs">
                <Text size="sm">{record.fromText}</Text>
                <AddToContactsButton onClick={onAddToContacts} />
            </Group>
        );
    }

    const properties = [
        {
            label: 'From',
            value: fromValue,
            span: 12,
        },
        {
            label: 'To',
            value: record.toText,
            span: 12,
        },
        {
            label: 'Subject',
            value: record.subject,
            span: 12,
        },
        {
            label: 'Received',
            value: formatTimestamp(record.date),
            span: 12,
        }
    ];

    const metadata = [
        {
            label: 'Message ID',
            value: record.messageId as string,
            span: 12,
        },
        {
            label: 'Status',
            value: record.status,
            span: 12,
        },
        {
            label: 'Html Path',
            value: record.htmlPath,
            span: 12,
        },
        {
            label: 'Created By',
            value: record.createdByUsername || 'n/a',
            rbac: rbacActions.UpdateMessage,
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Managed By',
            value: record.managedByUsername || 'n/a',
            rbac: rbacActions.UpdateMessage,
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }
    ];

    return { properties, metadata };
};
